export default __webpack_public_path__ + "static/snake-preview-1-3e4fcaec47a9e6582fa4bebcfc57e1d8.png";